const storeKeys = { 
    SessionObj : 'session',
    CurrentCard  : 'card',
 
};

export default storeKeys;